import "react-quill/dist/quill.snow.css";
import "./TextEditor.css";

import ReactQuill from "react-quill";

import EditorToolbar, { formats, modules } from "./EditorToolbar";

interface TextEditorProps {
	value: string;
	setValue: (value: string) => void;
	id?: string;
	placeholder?: string;
	readOnly?: boolean;
	className?: string;
	toggleEditorVisibility?: () => void;
}

const TextEditor = (props: TextEditorProps) => {
	const onChangeHandler = (value: string) => {
		props.setValue(value);
	};
	const id = props.id ? props.id : "editor";
	return (
		<>
			<EditorToolbar toolbarId={`${id}`} toggleEditorVisibility={props.toggleEditorVisibility} />
			<ReactQuill
				theme="snow"
				value={props.value}
				onChange={onChangeHandler}
				placeholder={props.placeholder}
				modules={modules(`${id}`)}
				formats={formats}
				readOnly={props.readOnly ? props.readOnly : false}
				className={props.className ? props.className : ""}
			/>
		</>
	);
};

export default TextEditor;
